import { lazy } from "react";

export const HomeAsync = lazy(() => import("./Home"));
